import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getConfigsFeaturesLocation = createAsyncThunk(
  'configs/getConfigsFeaturesLocation',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/configs?type=public&key=SETTING_INCLUDE_FEATURES_LOCATION`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
    }
  },
);
